module.exports = __webpack_public_path__ + "img/sea-5.bcc7621d.jpg";